namespace Roodik.Core
{
	export interface ITimer
	{
		milliseconds:number;
		seconds:number;
		
		stop();
		start();
		destroy();
	}
	
	export class Timer implements ITimer
	{
		private _timeStartGameMs : number;
		private _time : number = 0;
		private _timerId : number;
		private _pause : boolean = false;
		
		constructor(private _timerTick:(milliseconds:number)=>void)
		{
			this._timeStartGameMs = this.getCurrentTimeUTCms();
			this._timerId = setInterval(this.timerLoop.bind(this), 1000);
		}
		
		private timerLoop() : void
		{
			let currentTimeMs : number = this.getCurrentTimeUTCms();
			
			if(this._pause)
			{
				this._timeStartGameMs = currentTimeMs - this._time;
			}
			else
			{
				this._time = currentTimeMs - this._timeStartGameMs;
				this._timerTick(this._time);
			}
		}
		
		private getCurrentTimeUTCms() : number
		{
			return new Date().getTime();
		}
		
		public stop()
		{
			this._pause = true;
		}
		
		public start()
		{
			this._pause = false;
		}
		
		public get milliseconds() : number
		{
			return this._time;
		}
		
		public get seconds():number
		{
			return Math.round(this._time / 1000);
		}
		
		public destroy()
		{
			this._timerTick = null;
			clearInterval(this._timerId);
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Utility/Timer.ts